export default {
  getCandidate: (state) => state.candidate,
};
